//sellpoints
export const accountUserGetters = {
    // All sellpoints
    getUser: (state) => {
      return state.store_user
      //return JSON.parse(JSON.stringify(state.store_user));
    },// -> getters['account/getUser']
}
  
  //sellpoints
  export const accountSellpointGetters = {

    getUserBusinesses: (state) => {
      return state.store_sellpoints
    }, // -> getters['account/getUserBusinesses']

    getUserBusiness: (state) => {
      return state.store_sellpoint.store_sellpointData
    }, // -> getters['account/getUserBusinesses']
  
    setSellpoint: (state) => {
      return state.store_sellpoint.store_sellpointData
    },

    getSellpointAppSubscriptionOffers: (state) => {
      return state.store_sellpoint.store_sellpointAppSubscriptionOffers
    },

    getSellpointShipping: (state) => {
      return state.store_sellpoint.store_sellpointShipping
    },

    getSellpointDiscounts: (state) => {
      return state.store_sellpoint.store_sellpointDiscounts
    },
  
    // Get Sellpoint by ID
    sellpointById: (state, getters) => id => {
      if (getters.allSellpoints.length > 0) {
        return getters.allSellpoints.filter(p => p._id === id)[0]
      } else {
        return state.store_sellpoint
      }
    },

  }
  
  //categories
  export const accountCategoryGetters = {
    getBusinessCategories: (state) => {
      return state.store_sellpoint.store_categories
    }, // -> getters['account/getUserBusinessCategories']
    
    getCategory: (state) => {
      return state.store_sellpoint.store_category
    }, // -> getters['account/getUserBusinessCategory']
        
  }

  //products
  export const accountProductGetters = {
    getBusinessProducts: (state) => {
      return state.store_sellpoint.store_products
    }, 

    getProduct: (state) => {
      return state.store_sellpoint.store_product
    },

    // All products
    allProducts: (state, getters) => {
      return state.store_sellpoint.store_products
    },

    // Get Product by ID
    productById: (state, getters) => id => {
      if (getters.allProducts.length > 0) {
        return getters.allProducts.filter(p => p._id === id)[0]
      } else {
        return state.store_sellpoint.store_product
      }
    },

   }

    


// WEBPACK FOOTER //
// ./src/store/modules/account/getters.js